import dayjs from "dayjs";
import axios from "axios";
import config from "../../../config";


export async function fetchClusterInfo() {

    const POSTREST_URL = config.POSTREST_URL;
  const nowFormatted = dayjs().format("DD/MM/YYYY HH:mm");

  const res = await axios.get(`${POSTREST_URL}/rpc/get_cluster_counts_map`, {
    headers: {
      "Accept-Profile": "interventions",
    },
  });

  const rows = Array.isArray(res.data) ? res.data : [];

  const features = rows
    .filter((r) => r?.data?.buffer_geom?.coordinates)
    .map((r) => ({
      id: r.cluster_id,
      type: "Feature",
      properties: {
        cluster_id: r.cluster_id,
        name: `Cluster ${r.cluster_id}`,
        displayMessage: `Cluster Id ${r.cluster_id}`,
        accidents: Number(r?.data?.total_accidents ?? 0),
        indications: Number(r?.data?.total_suggestions ?? 0),
        interventions: Number(r?.data?.total_interventions ?? 0),
        latestUpdate: nowFormatted,
      },
      geometry: {
        type: "Polygon",
        // Your old code expects: data.buffer_geom.coordinates
        coordinates: r.data.buffer_geom.coordinates,
      },
    }));

  // Sort by cluster_id ascending (same behavior you already had)
  features.sort((a, b) => a.properties.cluster_id - b.properties.cluster_id);

  return {
    type: "FeatureCollection",
    features,
  };
}
